import type ViewFilter from 'owa-service/lib/contract/ViewFilter';
import {
    AttachRegular,
    CalendarRegular,
    FlagRegular,
    MailRegular,
    MailUnreadRegular,
    MentionRegular,
    SendRegular,
    ArrowCircleUpSparkleRegular,
} from '@fluentui/react-icons';

export function getViewFilterIcon(filter: ViewFilter | null): JSX.Element {
    switch (filter) {
        case 'All':
            return <MailRegular />;
        case 'Unread':
            return <MailUnreadRegular />;
        case 'Flagged':
            return <FlagRegular />;
        case 'ToOrCcMe':
            return <SendRegular />;
        case 'HasAttachment':
            return <AttachRegular />;
        case 'HasFile':
            return <AttachRegular />;
        case 'Mentioned':
            return <MentionRegular />;
        case 'HasCalendarInvite':
            return <CalendarRegular />;
        case 'CopilotHighPriority':
            return <ArrowCircleUpSparkleRegular />;
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Hashtag':
        case 'Liked':
        default:
            /* eslint-disable-next-line react/jsx-no-useless-fragment -- (https://aka.ms/OWALintWiki)
             * Don't use react fragments if there are no children
             *	> Fragments should contain more than one child - otherwise, there’s no need for a Fragment at all. */
            return <></>;
    }
}
